import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
}), 'SubdirectoryArrowLeftTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SubdirectoryArrowLeftTwoTone.js
// module id = 6557
// module chunks = 2